/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SendIcon = /*#__PURE__*/ createSvgIcon(
  'SendIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M16.25 10.688L4.02 15.582a.715.715 0 01-.697-.073.7.7 0 01-.323-.614V5.104a.7.7 0 01.323-.614.715.715 0 01.698-.073L16.25 9.313c.32.124.48.354.48.687 0 .333-.16.563-.48.688zM4.5 13.77L13.958 10 4.5 6.23V8.5L9 10l-4.5 1.5v2.27z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default SendIcon;
